/* ════════════════════════════════════════════════════
   KAMISHA MOTION - kamisha-motion.js

   Two jobs only:
     1. flag the hero as ready once its image has decoded, so the text can
        settle in without ever gating the LCP image on JS
     2. bundle 3 story parallax

   No scroll listeners anywhere. The parallax runs a rAF loop only while the
   element is actually on screen, started and stopped by IntersectionObserver.
   ════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var body = document.body;
  var bundle = body && body.getAttribute('data-motion');
  if (!bundle || bundle === '0') return;

  /* ─── 1. HERO ─────────────────────────────────────
     The hero text is hidden by CSS and revealed by .is-ready. A CSS failsafe
     animation also reveals it after 3s, so a JS failure can never leave the
     headline invisible - this only makes it arrive sooner and in sync with the
     image. */
  var hero = document.querySelector('.kh-hero');
  if (hero) {
    var markReady = function () {
      hero.classList.add('is-ready');
    };
    var heroImg = hero.querySelector('.kh-hero__img');

    if (!heroImg) {
      markReady();
    } else if (heroImg.complete && heroImg.naturalWidth > 0) {
      /* already in cache - wait one frame so the transition still runs */
      requestAnimationFrame(markReady);
    } else {
      heroImg.addEventListener('load', markReady, { once: true });
      heroImg.addEventListener('error', markReady, { once: true });
      /* never let a stalled image hold the headline hostage */
      setTimeout(markReady, 2000);
    }
  }

  /* ─── 2. STORY PARALLAX (bundle 3 only) ───────────── */
  if (bundle !== '3') return;
  if (!('IntersectionObserver' in window)) return;

  var storyImg = document.querySelector('.kh-story__img img');
  var storyBox = document.querySelector('.kh-story__img');
  if (!storyImg || !storyBox) return;

  var MAX_SHIFT = 3;           /* percent of travel, each direction */
  var running = false;
  var frame = null;

  function tick() {
    var rect = storyBox.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;

    /* progress: 0 when the box's top hits the bottom of the viewport,
       1 when its bottom leaves the top */
    var span = rect.height + vh;
    var progress = (vh - rect.top) / span;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    var shift = (0.5 - progress) * 2 * MAX_SHIFT;
    storyImg.style.transform = 'translate3d(0,' + shift.toFixed(2) + '%,0) scale(1.08)';

    if (running) frame = requestAnimationFrame(tick);
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        if (!running) { running = true; frame = requestAnimationFrame(tick); }
      } else {
        running = false;
        if (frame) { cancelAnimationFrame(frame); frame = null; }
      }
    }
  }, { rootMargin: '10% 0px 10% 0px' });

  io.observe(storyBox);
})();
